export default function Hero() {
  const thumbs = [
    {
      src: "https://readdy.ai/api/search-image?query=Minimalist%20matte%20black%20smooth%20egg-shaped%20AI%20assistant%20device%20on%20clean%20light%20gray%20studio%20background%2C%20soft%20diffused%20lighting%2C%20high-end%20industrial%20product%20photography%2C%20monochrome%20aesthetic%2C%20subtle%20reflections%2C%20premium%20matte%20metallic%20finish%2C%20centered%20composition%2C%20editorial%20style&width=400&height=400&seq=topbud-thumb-01&orientation=squarish",
      alt: "Topbud device front view",
    },
    {
      src: "https://readdy.ai/api/search-image?query=Sleek%20futuristic%20black%20pebble%20shaped%20smart%20speaker%20device%20isolated%20on%20light%20neutral%20studio%20background%2C%20polished%20dark%20metallic%20surface%20with%20soft%20highlight%2C%20professional%20product%20photography%2C%20minimalist%20aesthetic%2C%20clean%20composition%2C%20cinematic%20lighting&width=400&height=400&seq=topbud-thumb-02&orientation=squarish",
      alt: "Topbud device side view",
    },
    {
      src: "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20small%20matte%20black%20rounded%20AI%20voice%20assistant%20device%20standing%20upright%20on%20soft%20gray%20paper%20surface%2C%20elegant%20industrial%20design%2C%20dramatic%20studio%20lighting%2C%20refined%20monochrome%20product%20shot%2C%20minimalist%20high-end%20aesthetic&width=400&height=400&seq=topbud-thumb-03&orientation=squarish",
      alt: "Topbud device detail view",
    },
  ];

  return (
    <section id="top" className="relative w-full flex-1 flex flex-col min-h-0 px-6 md:px-10 pt-6">
      {/* Top area: left info + right media */}
      <div className="grid grid-cols-[1fr_1fr] gap-0 flex-1 min-h-0">
        {/* LEFT — Info column */}
        <div className="flex flex-col justify-between h-full pr-10 min-h-0">
          {/* Top block */}
          <div className="max-w-md">
            <div
              className="anim-fade-up font-label text-[11px] tracking-[0.22em] uppercase text-foreground-500 leading-relaxed"
              style={{ animationDelay: "80ms" }}
            >
              <p>Pre-Order</p>
            </div>

            <p
              className="anim-fade-up mt-8 text-[13px] leading-[1.7] text-foreground-700 text-justify"
              style={{ animationDelay: "200ms" }}
            >
              Topbud is an advanced AI-powered virtual assistant designed to go
              beyond traditional voice assistants like Siri. With state-of-the-art
              natural language processing, personalized learning, and deep
              contextual awareness, NOVA seamlessly integrates into your daily
              life, acting as a digital companion for productivity, well-being,
              and smart living.
            </p>

            {/* CTA buttons */}
            <div
              className="anim-fade-up mt-6 flex flex-row gap-3"
              style={{ animationDelay: "340ms" }}
            >
              <a
                href="#preorder"
                className="cursor-pointer whitespace-nowrap inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 text-[11px] font-label tracking-[0.18em] uppercase hover:bg-primary-600 transition-colors duration-200"
              >
                <span>Pre-Order Now</span>
                <i className="ri-arrow-right-up-line text-[13px]" />
              </a>
              <a
                href="#learn"
                className="cursor-pointer whitespace-nowrap inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-full border border-foreground-300 text-foreground-900 text-[11px] font-label tracking-[0.18em] uppercase hover:bg-background-100 transition-colors duration-200"
              >
                <span>Learn More</span>
              </a>
            </div>
          </div>

          {/* Bottom launch meta */}
          <div
            className="anim-fade-up"
            style={{ animationDelay: "460ms" }}
          >
            <p className="font-label text-[11px] tracking-[0.22em] uppercase text-foreground-600">
              Launching <span className="text-foreground-950">— July 20th, 2025</span>
            </p>
          </div>
        </div>

        {/* RIGHT — Media column */}
        <div className="relative flex flex-row gap-4 items-stretch h-full min-h-0">
          {/* Thumb column */}
          <div className="flex flex-col gap-4 w-[130px] justify-start">
            {thumbs.map((t, i) => (
              <div
                key={t.alt}
                className="anim-fade-up relative w-[130px] h-[130px] rounded-lg overflow-hidden bg-background-100 border border-background-200 flex-shrink-0"
                style={{ animationDelay: `${300 + i * 120}ms` }}
              >
                <img
                  src={t.src}
                  alt={t.alt}
                  className="w-full h-full object-cover object-top cursor-pointer transition-transform duration-500 hover:scale-105"
                />
              </div>
            ))}
          </div>

          {/* Big hero image */}
          <div
            className="anim-fade-up-big relative flex-1 rounded-lg overflow-hidden bg-background-100 border border-background-200 h-full"
            style={{ animationDelay: "120ms" }}
          >
            <img
              src="https://readdy.ai/api/search-image?query=Extreme%20close%20up%20macro%20shot%20of%20a%20matte%20black%20AI%20voice%20assistant%20device%20with%20smooth%20curved%20metallic%20shell%20and%20one%20large%20deep%20dark%20circular%20lens%20eye%20in%20the%20center%2C%20premium%20industrial%20design%2C%20soft%20studio%20lighting%20with%20subtle%20highlights%2C%20monochrome%20gray%20background%2C%20high-end%20product%20photography%2C%20minimalist%20futuristic%20aesthetic%2C%20cinematic%20detail%2C%20refined%20surface%20texture&width=1200&height=1400&seq=topbud-hero-main&orientation=portrait"
              alt="Topbud AI device main"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>

      {/* Giant wordmark */}
      <div
        className="anim-fade-up-big w-full overflow-hidden shrink-0"
        style={{ animationDelay: "550ms" }}
      >
        <h1
          className="font-heading font-semibold leading-[0.85] tracking-[-0.04em] select-none relative"
          style={{
            fontSize: "clamp(80px, 14vw, 220px)",
            backgroundColor: "oklch(var(--foreground-950))",
            backgroundImage: [
              "radial-gradient(oklch(var(--background-50)) 1px, transparent 1.2px)",
              "linear-gradient(180deg, oklch(var(--foreground-950)) 0%, oklch(var(--foreground-950)) 35%, oklch(var(--foreground-700)) 60%, oklch(var(--foreground-400)) 82%, oklch(var(--foreground-200)) 100%)",
            ].join(", "),
            backgroundSize: "4px 4px, 100% 100%",
            backgroundPosition: "0 0, 0 0",
            backgroundRepeat: "repeat, no-repeat",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          TOPBUD
        </h1>
      </div>
    </section>
  );
}